import React, { useRef } from "react"

import { useScrollableElementBoundaries } from "../../hooks/scrollableElementBoundaries.hook"

export const ProduktlyTableWrapperComponent: React.FunctionComponent<
    IProduktlyTableWrapperComponentProps
> = props => {
    const containerRef = useRef<HTMLDivElement>(null)

    const containerBoundaries = useScrollableElementBoundaries(containerRef)

    return (
        <div ref={containerRef} className={`relative ${props.className ?? ""}`}>
            {/*
              Empty on purpose. Children can overflow horizontally; a tour
              measuring this node gets the viewport box. `right` shifts it
              back as the window scrolls sideways. No `left`: with `w-full`
              set, a left offset would ignore right.
            */}
            <div
                data-produktly={props.dataProduktly}
                className="pointer-events-none absolute inset-y-0 w-full"
                style={{
                    right: containerBoundaries?.x,
                }}
                aria-hidden
            />

            {props.children}
        </div>
    )
}

interface IProduktlyTableWrapperComponentProps {
    children?: React.ReactNode
    className?: string
    dataProduktly: string
}
